import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './AdminPagos.css';

const AdminPagos = () => {
    const [pagos, setPagos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchPagos = async () => {
            try {
                setLoading(true);
                const res = await api.get('/admin/pagos');
                setPagos(res.data);
            } catch (err) {
                setError(err.response?.data?.message || 'Error al cargar pagos');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchPagos();
    }, []);

    const formatearMoneda = (monto) =>
        new Intl.NumberFormat('es-AR', {
            style: 'currency',
            currency: 'ARS',
            minimumFractionDigits: 0,
        }).format(monto || 0);

    const formatearFecha = (fecha) =>
        new Date(fecha).toLocaleString('es-AR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });

    const pagosFiltrados = pagos.filter((p) => {
        const matchEstado = filtroEstado === 'all' || p.estado === filtroEstado;
        const term = searchTerm.toLowerCase();
        const matchSearch =
            !searchTerm ||
            (p.paciente?.nombre || '').toLowerCase().includes(term) ||
            (p.paciente?.email || '').toLowerCase().includes(term) ||
            (p.mpPaymentId || '').toString().includes(term);
        return matchEstado && matchSearch;
    });

    const totalRecaudado = pagosFiltrados
        .filter((p) => p.estado === 'approved')
        .reduce((acc, p) => acc + (p.monto || 0), 0);

    return (
        <div className="admin-pagos">
            {/*<div className="admin-pagos-header">
                <h1>💰 Historial de Pagos</h1>
                <p className="admin-pagos-subtitle">
                    Seguimiento de señas y pagos recibidos
                </p>
            </div>*/}

            <div className="pagos-filtros">
                <div className="filter-group">
                    <button
                        className={`filter-btn ${filtroEstado === 'all' ? 'active' : ''}`}
                        onClick={() => setFiltroEstado('all')}
                    >
                        Todos
                    </button>
                    <button
                        className={`filter-btn ${filtroEstado === 'approved' ? 'active' : ''}`}
                        onClick={() => setFiltroEstado('approved')}
                    >
                        ✅ Aprobados
                    </button>
                    <button
                        className={`filter-btn ${filtroEstado === 'pending' ? 'active' : ''}`}
                        onClick={() => setFiltroEstado('pending')}
                    >
                        ⏳ Pendientes
                    </button>
                    <button
                        className={`filter-btn ${filtroEstado === 'rejected' ? 'active' : ''}`}
                        onClick={() => setFiltroEstado('rejected')}
                    >
                        ❌ Rechazados
                    </button>
                </div>
                <input
                    type="text"
                    className="form-control search-input"
                    placeholder="Buscar por paciente o ID de pago..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            <div className="pagos-resumen">
                <span>Total recaudado: <strong>{formatearMoneda(totalRecaudado)}</strong></span>
                <span>{pagosFiltrados.length} pagos</span>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            {loading ? (
                <div className="pagos-loading">Cargando pagos...</div>
            ) : pagosFiltrados.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-state-icon">💸</div>
                    <div className="empty-state-title">No hay pagos</div>
                    <div className="empty-state-text">
                        No se encontraron pagos con los filtros aplicados
                    </div>
                </div>
            ) : (
                <div className="pagos-tabla">
                    <div className="tabla-header">
                        <div>Fecha</div>
                        <div>Paciente</div>
                        <div>Monto</div>
                        <div>ID MP</div>
                        <div>Estado</div>
                    </div>
                    {pagosFiltrados.map((p) => (
                        <div key={p._id} className="tabla-row">
                            <div>{formatearFecha(p.createdAt)}</div>
                            <div>
                                {p.paciente
                                    ? `${p.paciente.nombre || ''} ${p.paciente.apellido || ''}`.trim()
                                    : 'N/A'}
                            </div>
                            <div className="monto">{formatearMoneda(p.monto)}</div>
                            <div className="mp-id">{p.mpPaymentId || '-'}</div>
                            <div>
                                <span className={`pago-badge pago-${p.estado}`}>
                                    {p.estado === 'approved' && '✅ Aprobado'}
                                    {p.estado === 'pending' && '⏳ Pendiente'}
                                    {p.estado === 'rejected' && '❌ Rechazado'}
                                    {!['approved', 'pending', 'rejected'].includes(p.estado) && p.estado}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AdminPagos;